import { Page } from '../entities/Page'

import { pksApiService } from '../services/pksApiService'

class PageCommunicator {
    async fetchPage(slug) {
        const pageEndpoint = `/pages/${slug}`
        const page = await pksApiService.fetchData(pageEndpoint)

        return new Page(page)
    }

    async fetchRCPage(slug) {
        const pageEndpoint = `/chamber-pages/${slug}`
        const page = await pksApiService.fetchData(pageEndpoint)

        return new Page(page)
    }
}

export const pageCommunicator = new PageCommunicator()
